var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.contests_updated &&
              !_vm.no_matches_active &&
              !_vm.checkIfTourIsActive() &&
              _vm.parentRoute === _vm.CFG_MODULES.GAME_PLAN.route,
            expression:
              "\n      contests_updated &&\n      !no_matches_active &&\n      !checkIfTourIsActive() &&\n      parentRoute === CFG_MODULES.GAME_PLAN.route\n    ",
          },
        ],
        staticClass: "new-update-section",
      },
      [
        _c(
          "button",
          {
            class: ["btn btn-update", _vm.contests_updated ? "active" : ""],
            attrs: { type: "submit" },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.loadUpdatedContestList.apply(null, arguments)
              },
            },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.translations.contest_list_updated) +
                "\n    "
            ),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.no_matches_active,
            expression: "!no_matches_active",
          },
        ],
        staticClass: "waf-head",
      },
      [
        _c("div", { staticClass: "head-wrap" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "swiper",
                  rawName: "v-swiper:category_slider",
                  value: _vm.options,
                  expression: "options",
                  arg: "category_slider",
                },
              ],
              ref: "category_slider",
            },
            [
              _c(
                "div",
                { staticClass: "swiper-wrapper" },
                _vm._l(_vm.in_match_categories, function (cat) {
                  return _c(
                    "a",
                    {
                      key: cat.category_id,
                      staticClass: "swiper-slide custom-slide",
                      class: [
                        {
                          active:
                            cat.category_id ===
                            (_vm.current_match &&
                              _vm.current_match.category_id),
                        },
                      ],
                      attrs: { href: _vm.getFirstNodeHref(cat.category_id) },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(cat.category_name) +
                          "\n          "
                      ),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }